module.exports = __webpack_public_path__ + "static/pexels-andrea-piacquadio-3769137-1a2228de2e44fded54f430d0a7825dbe.jpg";